import { useContext } from 'react';
import { DropdownContext } from './CustomDropdown';
import styles from './Dropdown.module.css';

export const CustomDropdownButton = ({ children, arrow = true, className = '', isBtnShow = true }) => {
    const { toggle } = useContext(DropdownContext);

    return (
        <>
            {isBtnShow ?
                <button className={`${styles.button} ${className}`} onClick={toggle}>
                    {children}
                    {arrow && <span className={styles.arrow}>▼</span>}
                </button>
                :
                <span onClick={toggle}>
                    {children}
                </span>
            }
        </>
    );
};
